<template>


<div class="interaction ">
    <label class="" >

    <input class="inp-cbx cbx"  type="checkbox" true-value="1"
           false-value="0" v-model="interaction.value"  @click="updateEmbedUrl($event,interaction.label)" style="display: none;"/>
        <div class="cbx">
        <span>

    <svg width="12px" height="10px" viewbox="0 0 12 10">
      <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
    </svg></span><span>{{interaction.label}}</span></div></label>
</div>
</template>
<script>
import { EventBus } from "../services/eventBus";
export default {
  props:{
    interaction:{
      type:Object
    }
  },
    methods:{
      updateEmbedUrl(event,interaction){
        this.interaction.value = event.target.checked ? 1 : 0;
        EventBus.$emit('interaction-changed',interaction);
        //alert(interaction);
      }
    }
}
</script>
<style scoped>
    html, body {
        height: 100%;
    }

   /* body {
        display: block;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        color: #223254;
    }*/

    .cbx {
        margin: auto;
        -webkit-user-select: none;
        user-select: none;
        cursor: pointer;
        /*padding-right: 35px;*/
    }
    .cbx span {
        display: inline-block;
        vertical-align: middle;
        transform: translate3d(0, 0, 0);
    }
    .cbx span:first-child {
        position: relative;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        transform: scale(1);
        vertical-align: middle;
        border: 1px solid #9098A9;
        transition: all 0.2s ease;
    }
    .cbx span:first-child svg {
        position: absolute;
        top: 3px;
        left: 2px;
        fill: none;
        stroke: #FFFFFF;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 16px;
        stroke-dashoffset: 16px;
        transition: all 0.3s ease;
        transition-delay: 0.1s;
        transform: translate3d(0, 0, 0);
    }
    .cbx span:first-child:before {
        content: "";
        width: 100%;
        height: 100%;
        background: #506EEC;
        display: block;
        transform: scale(0);
        opacity: 1;
        border-radius: 50%;
    }
    .cbx span:last-child {
        padding-left: 12px;
    }
    .cbx:hover span:first-child {
        border-color: #506EEC;
    }

    .inp-cbx:checked + .cbx span:first-child {
        background: #506EEC;
        border-color: #506EEC;
        animation: wave 0.4s ease;
    }
    .inp-cbx:checked + .cbx span:first-child svg {
        stroke-dashoffset: 0;
    }
    .inp-cbx:checked + .cbx span:first-child:before {
        transform: scale(3.5);
        opacity: 0;
        transition: all 0.6s ease;
    }

    @keyframes wave {
        50% {
            transform: scale(0.9);
        }
    }
    .interaction{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 5px;
    padding-right: 35px;
}
/* Customize the label (the container) */
.container-interaction {
  display: block;
  position: relative;
  padding-left: 22px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container-interaction input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
  border: 1px solid #b5b5b5
}

/* On mouse-over, add a grey background color */
.container-interaction:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container-interaction input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container-interaction input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container-interaction .checkmark:after {
  left: 4px;
  top: 2px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>




// WEBPACK FOOTER //
// node_modules/modal-export/src/components/Interactions.vue